import { deleteData, getData, patchData, postData } from "../api/api";
import { PagedModel, PlanStatus, SubscriptionPlan } from "../types/subscription";
import { buildReadQueryString } from "../lib/api/readQuery";

const BASE_URL = "/subscription-plan";

const toSearchParam = (search?: string) => {
  const value = String(search || "").trim();
  return value ? `name=ilike=${value}` : "";
};

export const subscriptionPlanService = {
  read: async (page: number = 0, size: number = 20, search?: string, fields?: string | string[]) => {
    return getData(
      `${BASE_URL}/read?${buildReadQueryString({
        page,
        size,
        sort: "createdDate,desc",
        search: toSearchParam(search) || undefined,
        fields,
      })}`,
    ) as Promise<PagedModel<SubscriptionPlan>>;
  },

  readById: async (id: string) => {
    return getData(`${BASE_URL}/read/${id}`) as Promise<SubscriptionPlan>;
  },

  findByStatus: async (status: PlanStatus) => {
    return getData(`${BASE_URL}/by-status?status=${encodeURIComponent(status)}`) as Promise<
      SubscriptionPlan[]
    >;
  },

  create: async (payload: SubscriptionPlan) => {
    return postData(`${BASE_URL}/create`, payload) as Promise<SubscriptionPlan>;
  },

  update: async (payload: SubscriptionPlan) => {
    return patchData(`${BASE_URL}/update`, payload) as Promise<SubscriptionPlan>;
  },

  delete: async (recordId: string) => {
    return deleteData(`${BASE_URL}/delete/${recordId}`) as Promise<Record<string, unknown>>;
  },
};

